jQuery(document).ready(function($) {

    // Move the login modal to the body to avoid z-index issues found on carousels
    $('#loginModal').appendTo('body');

    // Move the modal to the body to avoid z-index issues found on carousels
    $('#addToProject').appendTo('body');

    // Cache selectors for efficiency
    var $addNewProjectButton = $('.add-new-project button');
    var $projectNameInput = $('#projectName');
    var $projectNameInputClone = $projectNameInput.clone().prop('disabled', true).removeAttr('id');
    var $form = $('.add_to_project');

    // Add variation change handling
    if ($('.variations_form').length) {
        $('.variations_form').on('found_variation', function(event, variation) {
            // Update the add to project button's product ID
            const addToProjectBtn = $('.add-to-project-btn, [data-bs-target="#addToProject"]');
            if (addToProjectBtn.length) {
                addToProjectBtn.attr('data-tamco-product-id', variation.variation_id);
                
                // Update the hidden input in the modal form
                $('#addToProject input[name="product_id"]').val(variation.variation_id);
            }
        });
        
        // Reset handler when no variation is selected
        $('.variations_form').on('reset_data', function() {
            const addToProjectBtn = $('.add-to-project-btn, [data-bs-target="#addToProject"]');
            if (addToProjectBtn.length) {
                const originalProductId = $('.variations_form').data('product_id');
                addToProjectBtn.attr('data-tamco-product-id', originalProductId);
                
                // Reset the hidden input in the modal form
                $('#addToProject input[name="product_id"]').val(originalProductId);
            }
        });
    }

    function configureSwiperBehavior(swiperInstance) {

        // Set a higher threshold for swipe detection. 
        // Needed because small clicks would inadvertently move the Swiper
        swiperInstance.params.threshold = 10; // pixels
        swiperInstance.update();

        // Disable Swiper on button click
        $('button[data-bs-toggle="modal"]').on('click', function() {
            swiperInstance.disable();
        });

        // Re-enable Swiper when modal is closed
        $('.modal').on('hidden.bs.modal', function() {
            setTimeout(function() {
                swiperInstance.enable();
            }, 300); // Delay of 300ms
        });

        // Disable the buttons when Swiper is moving. 
        // Otherwise, the user could click on the button and open the modal and fetching the product ID would not work
        swiperInstance.on('slideChangeTransitionStart ', function() {
            $('button[data-bs-toggle="modal"]').prop('disabled', true);
        });

        // Re-enable the buttons when Swiper is done moving
        swiperInstance.on('slideChangeTransitionEnd', function() {
            $('button[data-bs-toggle="modal"]').prop('disabled', false);
        });
    }

    // Poll for Swiper availability on the homepage
    if (window.location.pathname == '/') {
        var maxWaitTime = 10000; // Maximum wait time in milliseconds
        var elapsedTime = 0;
        var intervalTime = 100; // Check every 100ms

        var swiperCheckInterval = setInterval(function() {  
            elapsedTime += intervalTime;

            // Use jQuery to select elements
            var $carouselElement = $('.e-widget-swiper'); 
            if ($carouselElement.length > 0 && typeof Swiper !== 'undefined') {
                clearInterval(swiperCheckInterval);
                var swiperInstance = $carouselElement.find('.swiper')[0].swiper;
                configureSwiperBehavior(swiperInstance);
            } else if (elapsedTime >= maxWaitTime) {
                clearInterval(swiperCheckInterval);
                console.warn('Swiper not available within the maximum wait time.');
            }
        }, intervalTime);
    }
    
    $(document).on('click', 'button[data-bs-toggle="modal"]', function() {
        // Get product details from data attributes or form fields
        var siteId = $(this).data('tamco-site-id');
        var productId = $(this).data('tamco-product-id');
        var nonce = $(this).data('tamco-nonce');
        var quantity = $(this).closest('.row').find('input[name="quantity"]').val();
        var type = $(this).closest('.row').find('input[name="type"]').val();

        // Fill in the modal's fields
        $('#addToProject input[name="site_id"]').val(siteId);
        $('#addToProject input[name="product_id"]').val(productId);
        $('#addToProject input[name="tamco_nonce"]').val(nonce);
        $('#addToProject input[name="quantity"]').val(quantity);
        $('#addToProject input[name="type"]').val(type);
    });

    $(document).on('click', '.add-new-project button', function(e) {
        // Hide the button
        $(this).hide();

        // Disable the original input and insert the clone
        $projectNameInput.prop('disabled', true);
        $projectNameInputClone.insertAfter($(this)).prop('disabled', false);
    });

    $(document).on('click', 'button[data-bs-dismiss="modal"]', function() {
        // Reset everything when the modal is closed
        $addNewProjectButton.show();
        $projectNameInputClone.remove();
        $projectNameInput.prop('disabled', false);

        // Reset form inputs and checkboxes
        $form[0].reset();

        // Clear the clone input
        $projectNameInputClone.val('');
    });

    // Allow the user to search through their projects
    $(document).on('keyup', '.project-list-search', function() {
        var value = $(this).val().toLowerCase();
        $('.project-list-wrapper .form-check').filter(function() {
            // Filter out the projects that don't match the search value but keep the ones that are checked
            var match = $(this).find('.form-check-label').text().toLowerCase().indexOf(value) > -1;
            var isChecked = $(this).find('.form-check-input').prop('checked');
            $(this).toggle(match || isChecked);
            return match || isChecked;
        });

        // Count the number of visible checkboxes
        var visibleCheckboxes = $('.project-list-wrapper .form-check:visible').length;

        // Add or remove the class based on the count
        if (visibleCheckboxes > 4) {
            $('.search-wrapper').addClass('scroll');
        } else {
            $('.search-wrapper').removeClass('scroll');
        }
    });

    // Make sure the save button is disabled until a checkbox is checked or input field is filled
    $('.add_to_project button[type="submit"]').prop('disabled', true);

    // Listen for changes on checkboxes and input field
    $(document).on('change keyup', 'input[type="checkbox"], input[name="new_project_name"]', function() {
        // Check if there is at least one checkbox checked or input field is filled
        if ($('input[type="checkbox"]:checked').length > 0 || $(this).val().trim() !== "") {
            // If so, enable the submit button
            $('button[type="submit"]').prop('disabled', false);
        } else {
            // If not, keep the submit button disabled
            $('button[type="submit"]').prop('disabled', true);
        }
    });

    $(document).on('submit', '.add_to_project', function(e) { 
        e.preventDefault();

        var $this = $(this); // Store reference to this

        var formData = $(this).serializeArray();
        var dataObject = {};

        $.each(formData, function(i, item) {
            if (item.name === 'project_id') {
                // If the project_id field already exists, push the new value to it
                // Otherwise, create a new array with the current value
                if (dataObject[item.name]) {
                    dataObject[item.name].push(item.value);
                } else {
                    dataObject[item.name] = [item.value];
                }
            } else {
                dataObject[item.name] = item.value;
            }
        });

        // Store the nonce value and remove it from dataObject
        var nonce = dataObject.tamco_nonce;
        delete dataObject.tamco_nonce;

        $this.find('input, button:not([data-bs-dismiss])').prop('disabled', true);
                
        $.ajax({
            url: this.action,
            type: this.method,
            dataType: 'json',
            data: {
                action: $(this).data('wp-action'),
                tamco_nonce: nonce,
                data: dataObject
            },
            success: function(response) {
                console.log(response);
                if (response.success) {
                    location.reload();
                } else {
                    $this.find('input, button:not([data-bs-dismiss])').prop('disabled', false);
                }
            },
            error : function(error) {
                $this.find('input, button:not([data-bs-dismiss])').prop('disabled', false);
            }
        });
    });
});